// https://vuex.vuejs.org/en/getters.html

export default {
  loading(state) {
    return state.loading;
  }
};
